<template>
  <section v-if="$role.restricAccess($route.name, 'view')">
    <breadcrumb-template
      :headtitle="$route.meta.title"
      :breadcrumbcurrent="$route.meta.title"
    ></breadcrumb-template>
    <v-card class="force-remove-box">
      <v-card-text class="force-custom-bg">
        <v-container fluid>
          <v-row dense class="d-flex justify-end mt-n2">
            <!-- <v-col cols="12" lg="2" class="span-label" v-if="$store.state.currentUser.agent_data.level == 0">
              <span>Level</span>
              <v-select
                class="regular-field remove-alignment-clear-icon"
                dense
                clearable
                :items="$filterLevels"
                item-text="text"
                item-value="value"
                label="Level"
                v-model="filter.level"
              ></v-select>
            </v-col> -->
            <!-- <v-col cols="12" lg="2" class="span-label">
              <span>Status</span>
              <v-select
                class="regular-field remove-alignment-clear-icon"
                dense
                clearable
                :items="['Active', 'Inactive']"
                label="Status"
                v-model="filter.status"
              ></v-select>
            </v-col> -->
            <v-col cols="12" lg="3">
              <v-text-field
                clearable
                dense
                class="regular-field"
                v-model="dt_searchQuery"
                label="Search any keyword"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="2" class="mt-7" style="padding-top:5px;">
              <v-btn
                color="green_button"
                class="float-right btn-block"
                @click="getDataFromApi()"
                >Search</v-btn
              >
            </v-col>

            <v-col
              cols="12"
              v-if="$role.restricAccess($route.name, 'add')"
              lg="2"
              class="mt-7"
              style="padding-top:5px;"
            >
              <v-btn
                color="green_button"
                class="float-right btn-block"
                @click="modalForm()"
                >Add {{ $agentName }}
                <!-- <span
                  style="margin-left:5px;text-transform:lowecase;"
                  v-html="$setNameManagerSupervisor()"
                ></span> -->
              </v-btn>
            </v-col>

            <v-col cols="12" class="mt-2">
              <v-data-table
                class="custom-header-color table-bordered table-striped "
                :headers="dt_headers"
                :items="dt_resultlist"
                item-key="id"
                :loading="dt_loading"
                :options.sync="dt_options"
                :server-items-length="dt_totalResult"
              >
                <template v-slot:[`item.status`]="{ item }">{{
                  item.status == 1 ? "Active" : "Inactive"
                }}</template>

                <template v-slot:[`item.created_at`]="{ item }"
                  >{{ item.created_at | datetime }}</template
                >

                <template v-slot:[`item.commissionover`]="{ item }"
                  >L2 = {{ item.commissionover["END2"]["commission"] }}% , 3D = {{ item.commissionover["3D"]["commission"] }}%</template
                >

                <template v-slot:[`item.credit`]="{ item }">
                  <v-avatar :size="$gold_coin_sm"
                    ><img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{
                    item.credit == null
                      ? 0.0
                      : item.credit | toNumberWithDecimal
                  }}</template
                >

                <template
                  v-slot:[`item.actions`]="{ item }"
                  v-if="$role.restricAccess($route.name, 'edit')"
                >
                  <v-btn-toggle block rounded>
                    <v-btn
                      class="remove-darken-button"
                      color="green_button"
                      dark
                      small
                      @click="modalForm(item)"
                      ><v-icon>mdi-pencil</v-icon></v-btn
                    >
                    <v-btn
                      color="red_button"
                      dark
                      small
                      @click="deleteData(item.id)"
                      ><v-icon>mdi-delete</v-icon></v-btn
                    >
                  </v-btn-toggle>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <section>
      <v-dialog v-model="dialogForm" width="600px" scrollable persistent>
        <v-card class="card-outline custom-color-dialog">
          <v-card-title class="headline headline_bg">
            <span v-if="modalUpdate">Update <span class="text-lowercase" v-html="$agentName"></span></span>
            <span v-else>Add <span class="text-lowercase" v-html="$agentName"></span></span>
          </v-card-title>

          <v-card-text>
            <v-row dense class="pt-6">
              <v-col cols="12" class="span-label">
                <span>Username</span>
                <v-text-field
                  dense
                  class="regular-field"
                  v-model="form.username"
                  label="Username"
                  :error-messages="formerror.username"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="span-label">
                <span>Contact number</span>
                <v-text-field
                  dense
                  class="regular-field"
                  v-model="form.contact_no"
                  label="Contact #"
                  type="number"
                  :error-messages="formerror.contact_no"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="6" class="span-label">
                <span>Password</span>
                <v-text-field
                  dense
                  class="regular-field"
                  v-model="form.password"
                  label="Password"
                  :error-messages="formerror.password"
                ></v-text-field>
              </v-col>
              <!-- <v-col
                cols="12"
                lg="6"
                v-if="canEditCommision"
                class="span-label"
              >
                <span>Comission (%)</span>
                <v-text-field
                  dense
                  class="regular-field"
                  hide-details
                  v-model="form.commission"
                  type="number"
                  label="Commission (%)"
                  :error-messages="formerror.commission"
                ></v-text-field>
              </v-col> -->
              <v-col cols="12" lg="6" class="span-label">
                <span>Commission (%)</span>
                <v-select
                  :items="defaultCommission"
                  hide-details
                  item-text="text"
                  item-value="value"
                  dense
                  class="regular-field"
                  v-model="form.commission"
                  type="number"
                  label="Commission (%)"
                  :error-messages="formerror.commission"
                  :readonly="readonlyCommission"
                ></v-select>
              </v-col>
              <v-col cols="12" class="form-col">
                <v-switch
                  color="info"
                  dense
                  inset
                  v-model="form.status"
                  label="Status"
                ></v-switch>
              </v-col>
              
              <v-col cols="12" lg="6" class="span-label" v-for="(item, key) in this.form.commissionoveride" :key="key">
                <span>Override {{ key }} commission</span>
                <v-select :items="defaultCommissionOveride[key]" :readonly="readonlyCommission" hide-details item-text="text" item-value="value" dense class="regular-field" v-model="item.commission" type="number" :label="key"></v-select>
              </v-col>
              
              <!-- <v-col cols="12" class="form-col">
                <v-switch
                  color="info"
                  dense
                  inset
                  v-model="form.canbet"
                  label="Traditional bet"
                ></v-switch>
              </v-col> -->
              
              <!-- <v-col cols="6" lg="4" class="form-col" v-if="$store.state.currentUser.agent_data.level == 0">
                                <v-switch dense inset v-model="form.is_void" label="Can void"></v-switch>
                            </v-col>
                            <v-col cols="6" lg="4" class="form-col" v-if="$store.state.currentUser.agent_data.level == 0">
                                <v-switch dense inset v-model="form.is_share_player" label="Share players"></v-switch>
                            </v-col> -->
            </v-row>
          </v-card-text>

          <!-- <v-divider></v-divider> -->
          <v-card-actions class="actionButtons pt-6">
            <v-row no-gutters>
              <v-col cols="12">
                <v-btn color="red_button" @click="dialogForm = false"
                  >Back</v-btn
                >
                <span v-if="$role.restricAccess($route.name, 'edit')"
                  ><v-btn
                    color="green_button"
                    class="float-right"
                    @click="updateData"
                    v-if="modalUpdate"
                    :loading="isLoadingBtn"
                    >Update</v-btn
                  ></span
                >
                <v-btn
                  color="green_button"
                  class="float-right"
                  @click="newData"
                  v-if="!modalUpdate"
                  :loading="isLoadingBtn"
                  >Save</v-btn
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </section>

    <confirm-dialog ref="confirm"></confirm-dialog>
  </section>
</template>

<script>
export default {
  data() {
    return {
      defaultCommission: [ ],
      defaultCommissionOveride: [ ],
      dialogForm: false,
      isLoadingBtn: false,
      formerror: {},
      modalUpdate: false,
      dt_headers: [
        // {
        //   text: "Account #",
        //   value: "account_no",
        //   name: "account_no",
        //   sortable: false,
        //   searchable: true,
        // },
        {
          text: "Username",
          value: "username",
          name: "username",
          sortable: false,
          searchable: true,
        },
        {
          text: "Level",
          value: "level",
          name: "level",
          sortable: false,
          searchable: false,
        },
        {
          text: "Parent",
          value: "parent",
          name: "parent",
          sortable: false,
          searchable: false,
        },
        {
          text: "Commission (%)",
          value: "commissionover",
          name: "commissionover",
          sortable: false,
          searchable: true,
        },
        {
          text: "Contact #",
          value: "mobilenumber",
          name: "mobilenumber",
          sortable: false,
          searchable: true,
        },
        // { text: 'Credit balance', value: 'credit', name: 'credit', sortable: false, searchable: true},
        {
          text: "Status",
          value: "status",
          name: "status",
          sortable: false,
          searchable: true,
        },
        {
          text: "Date created",
          value: "created_at",
          name: "created_at",
          sortable: false,
          searchable: true,
        },

        {
          text: "Action",
          value: "actions",
          sortable: false,
          searchable: false,
          width: "10%",
        },
      ],
      dt_options: {},
      dt_columns: {},
      dt_totalResult: 0,
      dt_searchInput: "",
      dt_searchQuery: "",
      dt_resultlist: [],
      dt_loading: true,
      dt_itemsPerPage: 50,
      dt_reload: "",
      filter: {
        level: null,
        status: null,
      },
      form: new this.$Form({
        id: null,
        account_no: null,
        username: "",
        name: "",
        lname: "",
        commission: 0,
        status: 1,
        password: "",
        is_subagent: 0,
        subagent_id: "",
        contact_no: "",
        is_void: 0,
        is_share_player: 0,
        canbet: 1,
        commissionoveride: [],
      }),
      canEditCommision: false,
      readonlyCommission: false,
    };
  },
  methods: {
    async isReadonlyCommission(){

    },
    async commidisplay(){
      let minCommission = 1;
      let maxCommission = 40;
      let multiplier = 1;

      this.defaultCommission = [];
      if(this.$store.state.currentUser.agent_data.level > 0){
        minCommission = 1;
        multiplier = 1;

        for (let index = minCommission; index <= this.$store.state.currentUser.agent_data.commission; index += multiplier) {
          this.defaultCommission.push({
            text: index + "%", value: index
          })
        }
        this.commiOverideCommiList(minCommission, this.$store.state.currentUser.agent_data.commission, multiplier);
      }else{
        for (let index = minCommission; index <= maxCommission; index += multiplier) {
          this.defaultCommission.push({
            text: index + "%", value: index
          })
        }
        this.commiOverideCommiList(minCommission, maxCommission, multiplier);
      }
    },
    async commiOverideCommiList(minCommission, maxCommission, multiplier){
      this.$_.each(this.form.commissionoveride, ( val, key ) => {
        let parentAgentMaxcommi = this.$store.state.currentUser.agent_data.commissionOveride[key].commission;
        let newMaxCommission = (parentAgentMaxcommi) ? parentAgentMaxcommi : maxCommission;
        this.defaultCommissionOveride[key] = []; // INITIALIZE INDEX
        for (let index = minCommission; index <= newMaxCommission; index += multiplier){
          this.defaultCommissionOveride[key].push(
            { text: index + "%", value: index }
          )
        }

        if(this.modalUpdate == true && this.$store.state.currentUser.agent_data.commissionOveride[key].disableedit == true){
          this.readonlyCommission = true; 
        }else{
          this.readonlyCommission = false;
        }
      });
    },
    async modalForm(data) {
      this.canEditCommision = false;
      this.form.reset();
      
      if(data){
        this.modalUpdate = true;
        this.form.fill(data);
        this.form.contact_no = data.mobilenumber;
        await this.getCommiOverideList(this.form.id);
      }else{
        this.form.commission = 10;
        this.modalUpdate = false;
        await this.getCommiOverideList(null);
      }
      
      await this.commidisplay();

      if (!this.$store.state.currentUser.agent_data.level == 0) {
        this.canEditCommision = true;
      }

      this.dialogForm = true;
    },
    async getCommiOverideList(id){
      await this.form
        .post(this.$_CONFIG.api() + '/getcommioveride', { agent_id : id})
        .then(({ data }) => {
          this.form.commissionoveride = data;
        })
        .catch((error) => {
          this.isLoadingBtn = false;
          this.formerror = error.response.data;
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
    newData() {
      this.isLoadingBtn = true;
      this.form
        .post(this.$_CONFIG.api("API_SUB_AGENT"))
        .then(({ data }) => {
          this.isLoadingBtn = false;
          this.getDataFromApi();
          this.dialogForm = false;
          // this.$Swal.fire(
          //   "Success!",
          //   "Record has been successfully added.",
          //   "success"
          // );
          this.$toast.fire({
            icon: "success",
            title: "Record has been successfully added.",
          });
          this.formerror = {};
        })
        .catch((error) => {
          this.isLoadingBtn = false;
          this.formerror = error.response.data;
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
    updateData() {

      // console.log(this.form.commissionoveride);
      this.isLoadingBtn = true;
      this.form
        .put(this.$_CONFIG.api("API_SUB_AGENT") + "/" + this.form.id)
        .then(() => {
          this.isLoadingBtn = false;
          this.dialogForm = false;
          this.getDataFromApi();
          this.$toast.fire({ icon: "success", title: "Record has been successfully updated.", });
          this.formerror = {};
        })
        .catch((error) => {
          this.isLoadingBtn = false;
          this.formerror = error.response.data;
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
    async deleteData(id) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to delete this record?"
        )
      ) {
        this.form
          .delete(this.$_CONFIG.api("API_SUB_AGENT") + "/" + id)
          .then(() => {
            this.dialogForm = false;
            this.getDataFromApi();
            // this.$Swal.fire(
            //   "Deleted!",
            //   "Record has been successfully deleted",
            //   "success"
            // );
            this.$toast.fire({
              icon: "success",
              title: "Record has been successfully deleted.",
            });
          })
          .catch(() => {
            this.$toast.fire({ icon: "error", title: "Something went wrong!" });
          });
      }
    },
    paramsfilter() {
      return {
        ...this.dt_options,
        searchdata: this.dt_searchQuery,
        level: this.filter.level,
        status: this.filter.status,
      };
    },
    async getDataFromApi() {
      this.dt_loading = true;
      var paramsfilter = await this.paramsfilter();
      this.dt_columns = await this.$YajraDT.setHeader(this.dt_headers);
      let params = await this.$YajraDT.params(
        paramsfilter,
        this.dt_options,
        this.dt_itemsPerPage,
        this.dt_columns
      );
      let apiPath = await this.$_CONFIG.api("API_SUB_AGENT");

      await this.$axios
        .get(apiPath + "?" + this.$.param(params))
        .then((res) => {
          if (this.dt_totalResult != res.data.recordsFiltered) {
            this.dt_options.page = 1;
          }

          this.dt_resultlist = res.data.data;
          this.dt_totalResult = res.data.recordsFiltered;
          this.dt_loading = false;
        })
        .catch((err) => {
          this.dt_loading = false;
          console.log("Error searching");
        });

      var unwatch = this.$watch(
        "dt_options.page",
        function(newValue, oldValue) {
          this.getDataFromApi();
          unwatch();
        },
        { deep: true }
      );
    },
  },
  async created() {
    await this.getDataFromApi();
  },
  mounted() {},
};
</script>
<style scoped></style>